<button [menuFor]="men" class="margin-left">
    <svg-icon icon="icon-bars" class="tiny white"></svg-icon>
</button>

<menu #printMenu>
   <data-table-print-options></data-table-print-options>
</menu>

<menu #men>
    <div menu-item [menuFor]="printMenu">Export</div>
</menu>

